import CardTitle from '@/views/components/Cards/CardTitle';
import MyPieChart from '@/views/components/Charts/MyPieChart';
import Paper from '@/views/components/Paper/Paper';
import { Col, Row } from 'antd';
import StackedBar from '../../common/StackedBar';
import ClaimBarChartForProduct from './ClaimBarChartForProduct';
import ClaimsStackedBarChart from './ClaimsStackedBarChart';
import {
  CLAIMS_BY_REASONS_SAMPLE_DATA,
  CLAIMS_BY_STATUS_SAMPLE_DATA,
  ORIGIN_LOCATION_SAMPLE_DATA,
  PRODUCT_CHART_SAMPLE_DATA,
} from './constants';

const LDClaimDashboard = () => {
  return (
    <div className="h-100 d-flex flex-direction-column p-16 justify-content-between">
      <Row gutter={15} className="h-49">
        <Col md={24} lg={8} className="h-100">
          <Paper className="h-100 d-flex flex-direction-column overflow-visible" border>
            <div>
              <CardTitle title="Top Transportation Providers With Claims Paid" />
            </div>
            <div className="p-10 flex-1 d-flex flex-direction-column justify-content-center">
              <StackedBar />
            </div>
          </Paper>
        </Col>
        <Col md={24} lg={8} className="h-100">
          <Paper className="h-100 d-flex flex-direction-column overflow-visible" border>
            <div>
              <CardTitle title="Top Transportation Providers With Claims Filed" />
            </div>
            <div className="p-10 flex-1 d-flex flex-direction-column justify-content-center">
              <StackedBar />
            </div>
          </Paper>
        </Col>
        <Col md={24} lg={8} className="h-100">
          <Paper className="h-100 d-flex flex-direction-column overflow-visible" border>
            <div>
              <CardTitle title="Top 10 Products" />
            </div>
            <div className="p-10 flex-1 d-flex flex-direction-column justify-content-center">
              <ClaimBarChartForProduct data={PRODUCT_CHART_SAMPLE_DATA} />
            </div>
          </Paper>
        </Col>
      </Row>
      <Row gutter={15} className="h-49">
        <Col md={24} lg={10} className="h-100">
          <Paper className="h-100 d-flex flex-direction-column" border>
            <div>
              <CardTitle title="Claims by Origin Location (Top 10)" />
            </div>
            <div className="p-10 flex-1 d-flex flex-direction-column justify-content-center">
              <ClaimsStackedBarChart data={ORIGIN_LOCATION_SAMPLE_DATA} />
            </div>
          </Paper>
        </Col>
        <Col md={24} lg={7} className="h-100">
          <Paper className="h-100 d-flex flex-direction-column" border>
            <div>
              <CardTitle title="Claims By Status" />
            </div>
            <div className="p-10 flex-1 d-flex flex-direction-column justify-content-center">
              <MyPieChart data={CLAIMS_BY_STATUS_SAMPLE_DATA} palette="darkViolet" withLegend outerRadius={80} />
            </div>
          </Paper>
        </Col>

        <Col md={24} lg={7} className="h-100">
          <Paper className="h-100 d-flex flex-direction-column" border>
            <div>
              <CardTitle title="Claims By Reasons (Top 5)" />
            </div>
            <div className="p-10 flex-1 d-flex flex-direction-column justify-content-center">
              <MyPieChart data={CLAIMS_BY_REASONS_SAMPLE_DATA} withLegend outerRadius={80} palette="pastel" />
            </div>
          </Paper>
        </Col>
      </Row>
    </div>
  );
};

export default LDClaimDashboard;
